import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import Select from 'react-select';
import config from '../../config/config';
import axios from "axios";
import { getAuthToken } from '../../utils/token';
import { toast } from 'react-toastify';

const ManpowerAllocationModal = ({ show, handleClose, machineOperator, selectedMachineForAssign }) => {

  const operators = machineOperator?.operators || [];
  const machines = machineOperator?.machines || [];

  const [selectedMachine, setSelectedMachine] = useState(null);
  const [selectedOperator, setSelectedOperator] = useState(null);
  const [selectedSecondaryOperators, setSelectedSecondaryOperators] = useState([]);
  const [selectedShift, setSelectedShift] = useState(null);

  const assignOperator = async (operator_id, machine_id) => {
    const token = getAuthToken();
    if (!token) {
      toast.error("Authentication failed");
      return;
    }
    const storedUser = JSON.parse(localStorage.getItem('user'));
    const supervisorId = storedUser?.user?.id;

    const payload = {
      supervisor_id: supervisorId,
      operator_id: operator_id,
      machine_id: machine_id,
      shift: selectedShift?.value,
      secondary_operator_ids: selectedSecondaryOperators.map(op => op.value),
    };

    try {
      const response = await axios.post(
        `${config.API}/supervisor/assignoperator`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      toast.success(response.data?.message || "Operator assigned successfully");
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to assign operator");
    }
  };

  const handleUpdate = async () => {

    if (!selectedMachine) {
      toast.warning("Please select a machine");
      return;
    }

    if (!selectedOperator) {
      toast.warning("Please select a primary operator");
      return;
    }

    if (!selectedShift) {
      toast.warning("Please select shift");
      return;
    }

    await assignOperator(selectedOperator.value, selectedMachine.value);

    setSelectedMachine(null);
    setSelectedOperator(null);
    setSelectedSecondaryOperators([]);
    setSelectedShift(null);
    handleClose();
  };

  const machineOptions = machines.map(machine => ({
    value: machine?.id,
    label: machine?.machine_code
  }));

  const operatorOptions = operators.map(operator => ({
    value: operator?.id,
    label: operator?.name
  }));

  const shiftOptions = [
    { value: "day", label: "Day" },
    { value: "night", label: "Night" }
  ];



  return (
    <Modal show={show} onHide={handleClose} centered className='font_family'>
      <Modal.Body className='p-4'>
        <strong className="mb-0 fs-4">Manpower Allocation</strong>

        {/* Machine Select */}
        {/* Machine Select */}
        <div className="mt-3">
          <label className="mb-2">Machine</label>
          {selectedMachineForAssign ? (
            <div className="form-control bg-light">
              {selectedMachineForAssign}
            </div>
          ) : (
            <Select
              options={machineOptions}
              value={selectedMachine}
              onChange={setSelectedMachine}
              placeholder="Choose Machine..."
              isSearchable
            />
          )}
        </div>

        {/* Shift Select */}
        <div className="mt-4">
          <label className="mb-2">Select Shift</label>
          <Select
            options={shiftOptions}
            value={selectedShift}
            onChange={setSelectedShift}
            placeholder="Choose Shift..."
            isSearchable={false}
          />
        </div>

        {/* Primary Operator */}
        <div className="mt-4">
          <label className="mb-2">Primary Operator</label>
          <Select
            options={operatorOptions}
            value={selectedOperator}
            onChange={setSelectedOperator}
            placeholder="Choose Operator..."
            isSearchable
          />
        </div>

        {/* Secondary Operators */}
        <div className="mt-4">
          <label className="mb-2">Secondary Operators</label>
          <Select
            options={operatorOptions}
            value={selectedSecondaryOperators}
            onChange={setSelectedSecondaryOperators}
            placeholder="Choose Secondary Operators..."
            isSearchable
            isMulti
          />
        </div>

      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={handleClose}>Cancel</Button>
        <Button variant="dark" onClick={handleUpdate}>Update</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ManpowerAllocationModal;